export default __webpack_public_path__ + "static/media/servicetype_pcb.649fe684.png";